// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3O3eA","colBig":"styles_colBig__2rbG1","colSmall":"styles_colSmall__2qUQT","shopifyNameWrapper":"styles_shopifyNameWrapper__1Pzgw"};